import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, Input, ChangeDetectorRef } from '@angular/core';
import { Owner, Company, UserType, User } from 'toolbandi-ui-lib';
import { Search, CrudService, MessageService, SharedDataService, SortDirection } from 'elbuild-ui-lib-core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { forkJoin, Observable, Subscription, combineLatest } from 'rxjs';
import { OwnerEditComponent } from '../owner-edit/owner-edit.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DialogService, ListFiltersComponent } from 'elbuild-ui-componentslib';

@Component({
	selector: 'app-owner-list',
	templateUrl: './owner-list.component.html',
	styleUrls: ['./owner-list.component.scss']
})
export class OwnerListComponent implements OnInit, AfterViewInit, OnDestroy {

	loading: boolean = false;
	rows: Owner[];

	advancedSearch: Search = new Search('owner', `concat(fname,'',lname)`, 'owner');

	@ViewChild('listfilters', {}) listfilters: ListFiltersComponent;
	showAdvancedSearch: boolean = true;

	@Input()
	companyid: number;

	loggedUser: User;
	subcription: Subscription;

	constructor(
		private ownerService: CrudService<Owner>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private dialogService: DialogService,
		private router: Router,
		private cdr: ChangeDetectorRef,
		private modalService: NgbModal,
		private sharedDataService: SharedDataService) {

		this.advancedSearch.setSortDirection(SortDirection.ASCENDING);
		this.advancedSearch.setSortField('mgmttype');
	}

	ngAfterViewInit() {
		const urlparamsreq = this.listfilters.readParams();

		const requests: Observable<any>[] = [urlparamsreq];

		if (!this.loggedUser) {
			const userrequest = this.sharedDataService.currentLoggedUser;
			requests.push(userrequest);
		}

		this.subcription = combineLatest(requests).subscribe(data => {

			if (data[1]) {
				this.loggedUser = data[1];
			}
			if (this.loggedUser.utype === UserType.company) {
				this.companyid = this.loggedUser.companyid;
			}
			this.search(data[0]);

		});
	}

	ngOnInit() {

	}

	ngOnDestroy() {
		if (this.subcription) {
			this.subcription.unsubscribe();
		}
	}


	load() {
		this.loading = true;
		this.rows = [];
		this.cdr.detectChanges();

		if (this.companyid) {
			this.advancedSearch.addSimpleFilter('companyid', this.companyid);
		}

		const datarequest = this.ownerService.searchEntities(Owner, 'owner', this.advancedSearch, this.advancedSearch.page);
		const countrequest = this.ownerService.countEntities(Owner, 'owner', this.advancedSearch);

		forkJoin([datarequest, countrequest]).subscribe(results => {
			this.advancedSearch.page.setTotal(results[1].ct);
			this.rows = results[0];
			this.loading = false;
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
			this.loading = false;
		});
	}


	onPageChange(pageInfo: any) {

		this.advancedSearch.page.setPageNumber(pageInfo.offset);
		this.listfilters.addQueryParams();
		this.load();
	}

	onSortChange(sortInfo: any) {
		const sort = sortInfo.sorts[0];
		this.advancedSearch.setSortField(sort.prop);
		this.advancedSearch.setSortDirection(sort.dir);
		this.listfilters.addQueryParams();
		this.load();
	}

	onActivate(event: any) {
		if (true /*this.aclService.hasPermission('centri.detail')*/) {
			if (event.type === 'dblclick') {
				this.router.navigate([`/company/owner/view/${event.row.id}`], { queryParamsHandling: 'merge' });
			}
		}
	}


	search(searchParams?: any) {
		if (searchParams) {
			this.advancedSearch = searchParams;
		}
		this.load();
	}

	rowClass = (row: any) => {
		return '';
	}

	get page() {
		if (this.advancedSearch) {
			return this.advancedSearch.page;
		} else {
			return undefined;
		}
	}

	delete(row: Owner, event: any) {
		this.dialogService.openConfirmModal({
			message: this.translateService.instant('labels.warning-owner-delete'),
			hasIcon: true,
			type: 'warning'
		}).then(result => {
			if (result) {
				this.ownerService.deleteEntity(Owner, 'owner', row).subscribe(() => {
					this.translateService.get(['labels.owner-deleted', 'labels.owners']).subscribe(messages => {
						this.messageService.sendSuccess(messages['labels.owner-deleted'], messages['labels.owners']);
						this.load();
					});
				});
			}
		});
	}


	edit(ownerid?: number) {
		const modal = this.modalService.open(OwnerEditComponent, {
			centered: true,
			size: 'lg',
			backdrop: 'static',
			keyboard: false
		});

		modal.componentInstance.companyid = this.companyid;

		if (ownerid) {
			modal.componentInstance.load(ownerid);
		}
		modal.result.then((newItem: Owner) => {
			this.load();
		}).catch(() => {});
	}

}
